/**
 * Внешние ссылки проекта.
 * Личный кабинет участника живёт на отдельном поддомене.
 */
export const LK_URL = 'https://lk.o4ki.online/';
